import { requests } from "../../helpers/api.services";
import { DASHBOARD_URL } from "../../helpers/api.routes";

export const StatisticsService = {
    getLatest: () => requests.get(`${DASHBOARD_URL}/latest`),
    getGraphs: () => requests.get(`${DASHBOARD_URL}/graphs`),
    getStatistics: () => requests.get(`${DASHBOARD_URL}/statistics`),
    getLocationMap: (period: string, type: string) =>
        requests.get(`${DASHBOARD_URL}/location-map`, { period, type }),
};
